import { forwardRef } from "react"
import API from "web/hooks/data/api"
import { SelectX } from "web/components"

import { useSearch } from "web/hooks/data"

import { isObjectWithProperty } from "web/services/helpers"

import ControlContainer from "./ControlContainer"

const PortfolioLookup = forwardRef((props, ref) => {
  const {
    name,
    value,
    kind,
    error,
    touched,
    multiple_values,
    onChange,
    onFocus,
    autoFocus,
    disabled = false,
    canShowAddXOption = true,
  } = props

  const search = useSearch("portfolio")

  async function decodeValue(rawValue) {
    return { value: rawValue.value, label: rawValue.label, kind }
  }

  async function handleSelectXChange(value) {
    if (value === null) {
      onChange(null)
    } else if (multiple_values) {
      const decodedValue = []

      for (const valueEl of value) {
        decodedValue.push(await decodeValue(valueEl))
      }

      onChange(decodedValue)
    } else {
      onChange(await decodeValue(value))
    }
  }

  async function handleQuickAdd(nameOfNew) {
    const newObj = await API.post("/portfolios", { name: nameOfNew })

    if (isObjectWithProperty(newObj, "id")) {
      const newValue = { value: newObj.id, label: nameOfNew, kind }

      if (multiple_values) {
        onChange([...(value || []), newValue])
      } else {
        onChange(newValue)
      }
    }
  }

  return (
    <ControlContainer {...props} errorCondition={error && touched}>
      <SelectX
        ref={ref}
        name={name}
        value={value}
        onChange={handleSelectXChange}
        onFocus={onFocus}
        onAdd={canShowAddXOption ? handleQuickAdd : undefined}
        validValues={search}
        options={{
          multipleValues: multiple_values || false,
          clearOnFocus: true,
          inputClassName: "form-control lookup",
          autoFocus,
          placeholder: "Search portfolios...",
        }}
        disabled={disabled}
      />
    </ControlContainer>
  )
})

export default PortfolioLookup
